import { Dialog, styled } from "@mui/material";
import { useSelectedLayerSet } from "hooks/layerSetHooks";
import { LayerSet } from "types/types";
import { LayerSetDialogContent } from "./LayerSetDialogContent";
import { LayerSetDialogTitle } from "./LayerSetDialogTitle";

interface Props {
  layerSetId: number;
  layerSets: LayerSet[];
  deselectLayerSet: () => void;
}

export function LayerSetDialog(props: Props) {
  const { layerSetId, layerSets, deselectLayerSet } = props;
  const layerSet = useSelectedLayerSet(layerSetId, layerSets);

  return (
    <StyledDialog open={true} onClose={deselectLayerSet}>
      {layerSet && (
        <>
          <LayerSetDialogTitle
            layerSet={layerSet}
            deselectLayerSet={deselectLayerSet}
          />
          <LayerSetDialogContent layerSet={layerSet} />
        </>
      )}
    </StyledDialog>
  );
}

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    max-height: calc(100vh - 15%);
    max-width: calc(100vw - 15%);
    width: 100%;
    height: 100%;
  }
`;
